/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */

export type UserTypeFilter = typeof UserTypeFilter[keyof typeof UserTypeFilter];


export const UserTypeFilter = {
  Users: 'Users',
  Groups: 'Groups',
  UsersAndGroups: 'UsersAndGroups',
} as const;
